import { render, staticRenderFns } from "./StatisticsBillingCard.vue?vue&type=template&id=34cc8cc8&"
import script from "./StatisticsBillingCard.vue?vue&type=script&lang=js&"
export * from "./StatisticsBillingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports